<button  mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon class="icon-size-7 mt-1 text-dark" [ngClass]="{'icon-green': bundyy === 'Clock In'}">
         access_time_filled
    </mat-icon>
</button>

<mat-menu #menu="matMenu">
    <!-- <div (click)="bundy(0)"> -->
    <div [class.menu-item-selected]="bundyy === 'Clock In'" (click)="bundyNotification(0)">
        <button mat-menu-item *transloco="let t">
            <mat-icon class="icon-size-6">timer</mat-icon>
            <span>{{t('In')}}</span>
        </button>
    </div>
    <!-- <div (click)="bundy(1)"> -->
    <div [class.menu-item-selected]="bundyy === 'Clock Out'" (click)="bundyNotification(1)">
        <button mat-menu-item *transloco="let t">
            <mat-icon class="icon-size-6">timer_off</mat-icon>
            <span>{{t('Out')}}</span>
        </button>
    </div>

    <div *ngIf="this.is_webBreak" [class.menu-item-selected]="bundyy === 'Break Start'" (click)="bundyNotification(2)">
            <button mat-menu-item *transloco="let t">
                <mat-icon fontSet="material-icons-outlined" class="icon-size-6 break-icon">timer</mat-icon>
                <span>{{t('Break Start')}}</span>
            </button>
        </div>

        <!-- <div (click)="bundy(3)"> -->
        <div *ngIf="this.is_webBreak" [class.menu-item-selected]="bundyy === 'Break End'" (click)="bundyNotification(3)">
            <button mat-menu-item *transloco="let t">
                <mat-icon fontSet="material-icons-outlined" class="icon-size-6 break-icon">timer_off</mat-icon>
                <span>{{t('Break End')}}</span>
            </button>
        </div>

</mat-menu>
